
import React from 'react';

import { StoreContext, useStore } from '../context';


const RootProvider = ({ children }: any) => {

  const [appState, dispatch]: [any, any] = useStore();

  return (
    <StoreContext.Provider value={{ appState, dispatch }}>
      {children}
    </StoreContext.Provider>
  );

};

export default RootProvider;
